module.exports = __webpack_public_path__ + "assets/img/question.c90bb5a5.png";